import { mount, unmount } from 'svelte'
import PipSlot from '../video_player/PipSlot.svelte'
import { players } from '../video_player/players.svelte'

// The sidebar ghost the mini player is drawn over. It only takes up its 16:9 space while a player is
// docked, so the navigation around it makes room just then.
up.compiler('.player--pip-ghost', (element: HTMLElement) => {
  const slot = mount(PipSlot, { target: element })
  const stopObservingDocked = players.observeDocked((docked) => {
    element.classList.toggle('-visible', docked)
  })

  return () => {
    stopObservingDocked()
    void unmount(slot)
  }
})
